'use client';

import { useEffect } from 'react';

import { posthog } from '@/instrumentation-client';

const GCLID_KEY = 'gclid';

export const useGclidTracking = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const gclidFromUrl = params.get(GCLID_KEY);

    if (gclidFromUrl) {
      localStorage.setItem(GCLID_KEY, gclidFromUrl);
    }

    const gclid = gclidFromUrl ?? localStorage.getItem(GCLID_KEY);

    if (gclid) {
      posthog.register({ gclid });
    }
  }, []);
};
